/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { IOrderTemplateLineViewModel } from '../krannich-c-order-template';

export interface IOrderTemplateTableHeadingProps {
    selectAllRowsText?: string;
    productNumber: string;
    productName: string;
    productUnitPrice: string;
    productUOM: string;
    productQuantity: string;
    productActions: string;
    lines: IOrderTemplateLineViewModel[];
    isMobile: boolean;
    clickHandler(isChecked: boolean): void;
}

/**
 * Order Template's table state.
 */
export interface IOrderTemplateTableHeadingState {
    isChecked: boolean;
}

export interface IOrderTemplateTableShortHeading {
    productNumber: string;
    productActions: string;
}

/**
 * Order Template's table heading.
 */
export class OrderTemplateTableHeading extends React.PureComponent<IOrderTemplateTableHeadingProps> {
    public state: IOrderTemplateTableHeadingState = {
        isChecked: false
    };

    private readonly componentClassName: string = 'ms-table';

    public static getDerivedStateFromProps(
        props: IOrderTemplateTableHeadingProps,
        state: IOrderTemplateTableHeadingState
    ): IOrderTemplateTableHeadingState {
        const checkedLines = props.lines.filter(line => !line.isChecked).length;
        let nextState = { ...state };
        nextState = { isChecked: checkedLines === 0 };
        return nextState;
    }

    public getOnChange = () => (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState(
            {
                isChecked: this.state.isChecked
            },
            () => {
                this.props.clickHandler(!this.state.isChecked);
            }
        );
    };

    public render(): JSX.Element {
        return (
            <thead>
                <tr className={`${this.componentClassName}__heading-row`}>
                    <th scope='col' aria-label={this.props.selectAllRowsText}>
                        <label className='checkbox-container'>
                            <input
                                aria-label={this.props.selectAllRowsText}
                                className='checkbox-input'
                                type='checkbox'
                                aria-checked={this.state.isChecked}
                                checked={this.state.isChecked}
                                onChange={this.getOnChange()}
                            />
                            <span className='checkmark' />
                        </label>
                    </th>
                    {!this.props.isMobile ? <td>&nbsp;</td> : null}
                    {this.props.isMobile ? <th scope='col'>{this.props.productName}</th> : null}
                    {!this.props.isMobile ? <th scope='col'>{this.props.productNumber}</th> : null}
                    {!this.props.isMobile ? <th scope='col'>{this.props.productName}</th> : null}
                    {!this.props.isMobile ? <th scope='col'>{this.props.productUnitPrice}</th> : null}
                    {!this.props.isMobile ? <th scope='col'>{this.props.productUOM}</th> : null}
                    {!this.props.isMobile ? <th scope='col'>{this.props.productQuantity}</th> : null}
                    {!this.props.isMobile ? <th scope='col'>{this.props.productActions}</th> : <td />}
                </tr>
            </thead>
        );
    }
}
